module.exports = __webpack_public_path__ + "da050fc9a93e52003481d374e4e91119.png";